import { z } from 'zod';

export const feedbackTypeSchema = z.enum(['praise', 'improvement', 'coaching', 'recognition']);
export type FeedbackType = z.infer<typeof feedbackTypeSchema>;

export const feedbackStatusSchema = z.enum(['draft', 'submitted', 'acknowledged', 'archived']);
export type FeedbackStatus = z.infer<typeof feedbackStatusSchema>;

export const feedbackSchema = z.object({
  feedbackId: z.string(),
  employeeId: z.string(),
  employeeName: z.string(),
  employeeRole: z.string(),
  siteId: z.string(),
  siteName: z.string(),
  type: feedbackTypeSchema,
  category: z.string(),
  title: z.string(),
  content: z.string(),
  rating: z.number().min(1).max(5).optional(),
  submittedBy: z.string(),
  submittedByName: z.string(),
  status: feedbackStatusSchema,
  createdAt: z.string(),
  acknowledgedAt: z.string().nullable(),
});

export type Feedback = z.infer<typeof feedbackSchema>;

export const feedbackListResponseSchema = z.object({
  data: z.array(feedbackSchema),
  pagination: z.object({
    nextToken: z.string().nullable(),
    totalCount: z.number(),
  }),
});

export type FeedbackListResponse = z.infer<typeof feedbackListResponseSchema>;

export interface FeedbackFilters {
  employeeId?: string;
  type?: FeedbackType;
  status?: FeedbackStatus;
  siteId?: string;
  search?: string;
}

export function getFeedbackTypeColor(type: FeedbackType): string {
  const colors: Record<FeedbackType, string> = {
    praise: 'bg-green-100 text-green-700',
    improvement: 'bg-amber-100 text-amber-700',
    coaching: 'bg-blue-100 text-blue-700',
    recognition: 'bg-purple-100 text-purple-700',
  };
  return colors[type];
}

export function getFeedbackStatusColor(status: FeedbackStatus): string {
  const colors: Record<FeedbackStatus, string> = {
    draft: 'bg-gray-100 text-gray-700',
    submitted: 'bg-blue-100 text-blue-700',
    acknowledged: 'bg-green-100 text-green-700',
    archived: 'bg-gray-100 text-gray-500',
  };
  return colors[status];
}
